import React from 'react';
import { createBrowserRouter, Navigate, RouterProvider } from "react-router-dom";
import LoginPage from '../routes/LoginPage';
import HomePage from '../routes/HomePage';
import UserLogs from '../routes/UserLogs';
import UserBlacklist from '../routes/UserBlacklist';
import Leaderboard from '../routes/Leaderboard';

const Routing = () => {
    const router = createBrowserRouter([
        {
            path: "/",
            element: <LoginPage />
        },
        {
            path:"/home",
            element:<HomePage />
        },
        {
            path:"/user-logs",
            element:<UserLogs />
        },
        {
            path:"/user-blacklist",
            element:<UserBlacklist />
        },
        {
            path:"/leaderboard",
            element:<Leaderboard />
        },
        {
            path:"*",
            element:<Navigate to="/" />
        }
    ])
    return (
        <RouterProvider router={router} />
    )
}

export default Routing